var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"radioChoice"},_vm._l((_vm.radioList),function(item){return _c('li',{key:item.id,class:{active: _vm.checkId === item.id},on:{"click":function($event){return _vm.$emit('checkRadio',item.id)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }